var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 56,
    viewBox: "0 0 193 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.957 56H7.90416C4.00559 56 0.828979 52.8603 0.828979 49.0071V7.02141C0.828979 3.1682 4.00559 0.0285517 7.90416 0.0285517H184.957C188.856 0.0285517 192.032 3.1682 192.032 7.02141V49.0071C192.032 52.8603 188.827 56 184.957 56Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.957 1.11631C188.249 1.11631 190.906 3.7422 190.906 6.99602V48.9817C190.906 52.2356 188.249 54.8615 184.957 54.8615H7.90404C4.61191 54.8615 1.95512 52.2356 1.95512 48.9817V6.99602C1.95512 3.7422 4.61191 1.11631 7.90404 1.11631H184.957ZM184.957 0.0031611H7.90404C4.00547 0.0031611 0.828857 3.14281 0.828857 6.99602V48.9817C0.828857 52.835 4.00547 55.9746 7.90404 55.9746H184.957C188.855 55.9746 192.032 52.835 192.032 48.9817V6.99602C192.032 3.14281 188.827 0.0031611 184.957 0.0031611Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.976 14.3569C67.976 15.5272 67.6295 16.4691 66.9364 17.1541C66.1278 17.9818 65.0882 18.4099 63.8176 18.4099C62.6047 18.4099 61.5362 17.9818 60.6987 17.1541C59.8323 16.2978 59.3992 15.2703 59.3992 14.0144C59.3992 12.7586 59.8323 11.731 60.6987 10.9033C61.565 10.0756 62.6047 9.64746 63.8176 9.64746C64.424 9.64746 65.0016 9.76162 65.5503 9.98996C66.0989 10.2183 66.561 10.5323 66.8787 10.9319L66.1278 11.674C65.5503 11.0175 64.7994 10.675 63.7887 10.675C62.8934 10.675 62.1137 10.9889 61.4784 11.6169C60.8142 12.2448 60.4966 13.044 60.4966 14.043C60.4966 15.042 60.8142 15.8411 61.4784 16.4691C62.1426 17.097 62.9223 17.411 63.7887 17.411C64.7417 17.411 65.5214 17.097 66.1567 16.4691C66.561 16.0695 66.8209 15.4986 66.8787 14.7565H63.7887V13.7576H67.8894C67.976 13.9288 67.976 14.1286 67.976 14.3569Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5064 10.8461H70.6367V13.5005H74.131V14.4995H70.6367V17.154H74.5064V18.1815H69.5393V9.79004H74.5064C74.5064 9.81858 74.5064 10.8461 74.5064 10.8461Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1182 18.2098H78.0208V10.8459H75.6528V9.81836H81.4862V10.8459H79.1182V18.2098Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7039 18.2098V9.81836H86.8012V18.2098H85.7039Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6531 18.2098H90.5558V10.8459H88.1877V9.81836H94.0212V10.8459H91.6531V18.2098Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.084 17.1253C104.247 17.9815 103.207 18.4097 101.965 18.4097C100.723 18.4097 99.6838 17.9815 98.8464 17.1253C98.0089 16.269 97.6046 15.2415 97.6046 14.0142C97.6046 12.7868 98.0089 11.7308 98.8464 10.9031C99.6838 10.0468 100.723 9.61865 101.965 9.61865C103.207 9.61865 104.247 10.0468 105.084 10.9031C105.922 11.7593 106.355 12.7868 106.355 14.0142C106.326 15.2415 105.922 16.269 105.084 17.1253ZM99.655 16.4117C100.29 17.0396 101.041 17.3536 101.965 17.3536C102.86 17.3536 103.64 17.0396 104.275 16.4117C104.911 15.7838 105.228 14.9846 105.228 13.9856C105.228 12.9866 104.911 12.1875 104.275 11.5595C103.64 10.9316 102.889 10.6176 101.965 10.6176C101.041 10.6176 100.29 10.9316 99.655 11.5595C99.0196 12.1875 98.702 12.9866 98.702 13.9856C98.702 14.9846 99.0196 15.7838 99.655 16.4117Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.852 18.2098V9.81836H109.181L113.31 16.3546H113.368L113.31 14.7276V9.81836H114.408V18.2098H113.281L108.95 11.3597H108.892L108.95 12.9866V18.2098H107.852Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3198 30.4546C93.9988 30.4546 91.2842 32.9663 91.2842 36.4199C91.2842 39.845 93.9988 42.3852 97.3198 42.3852C100.641 42.3852 103.384 39.845 103.384 36.4199C103.384 32.9663 100.67 30.4546 97.3198 30.4546ZM97.3198 40.0162C95.5005 40.0162 93.9122 38.532 93.9122 36.4199C93.9122 34.2792 95.4716 32.8236 97.3198 32.8236C99.168 32.8236 100.727 34.2792 100.727 36.4199C100.727 38.532 99.1391 40.0162 97.3198 40.0162ZM84.1513 30.4546C80.8303 30.4546 78.1157 32.9663 78.1157 36.4199C78.1157 39.845 80.8303 42.3852 84.1513 42.3852C87.4723 42.3852 90.1869 39.845 90.1869 36.4199C90.1869 32.9663 87.4723 30.4546 84.1513 30.4546ZM84.1513 40.0162C82.332 40.0162 80.7437 38.532 80.7437 36.4199C80.7437 34.2792 82.332 32.8236 84.1513 32.8236C85.9706 32.8236 87.5589 34.2792 87.5589 36.4199C87.5301 38.532 85.9706 40.0162 84.1513 40.0162ZM68.4415 32.2813V34.8215H74.5637C74.3904 36.2487 73.8995 37.2762 73.1775 37.9897C72.2823 38.8745 70.8962 39.845 68.4415 39.845C64.6873 39.845 61.7417 36.848 61.7417 33.1375C61.7417 29.427 64.6873 26.4301 68.4415 26.4301C70.463 26.4301 71.9647 27.2293 73.062 28.2283L74.8525 26.4586C73.3219 25.003 71.3005 23.9184 68.4415 23.9184C63.2723 23.9184 58.9406 28.057 58.9406 33.1661C58.9406 38.2752 63.2723 42.4138 68.4415 42.4138C71.2427 42.4138 73.3219 41.5004 74.968 39.8164C76.6429 38.161 77.1916 35.792 77.1916 33.9082C77.1916 33.3088 77.1339 32.7665 77.0472 32.3384C77.0472 32.2813 68.4415 32.2813 68.4415 32.2813ZM132.609 34.2507C132.118 32.9092 130.588 30.4546 127.44 30.4546C124.35 30.4546 121.751 32.8807 121.751 36.4199C121.751 39.7594 124.292 42.3852 127.729 42.3852C130.501 42.3852 132.089 40.7298 132.753 39.7594L130.703 38.4179C130.01 39.4168 129.086 40.0733 127.729 40.0733C126.4 40.0733 125.418 39.4739 124.812 38.2752L132.869 34.9928C132.898 34.9072 132.609 34.2507 132.609 34.2507ZM124.408 36.2201C124.35 33.9367 126.198 32.738 127.555 32.738C128.595 32.738 129.49 33.2517 129.808 33.9938C129.779 34.0224 124.408 36.2201 124.408 36.2201ZM117.852 42.0142H120.509V24.5178H117.852V42.0142ZM113.521 31.7675H113.434C112.827 31.0825 111.701 30.4546 110.257 30.4546C107.254 30.4546 104.482 33.0805 104.482 36.4199C104.482 39.7594 107.254 42.3567 110.257 42.3567C111.701 42.3567 112.827 41.7288 113.434 41.0152H113.521V41.8715C113.521 44.1549 112.279 45.3822 110.315 45.3822C108.698 45.3822 107.687 44.2405 107.283 43.2701L104.973 44.2119C105.637 45.7818 107.398 47.7227 110.315 47.7227C113.434 47.7227 116.033 45.9245 116.033 41.529V30.8256H113.521V31.7675V31.7675ZM110.488 40.0162C108.669 40.0162 107.138 38.5035 107.138 36.4199C107.138 34.3078 108.669 32.795 110.488 32.795C112.279 32.795 113.694 34.3363 113.694 36.4199C113.694 38.5035 112.279 40.0162 110.488 40.0162ZM145.027 24.4892H138.702V41.9857H141.33V35.3638H145.027C147.972 35.3638 150.831 33.2517 150.831 29.9408C150.831 26.6014 147.943 24.4892 145.027 24.4892ZM145.085 32.9377H141.33V26.9439H145.085C147.048 26.9439 148.174 28.5708 148.174 29.9408C148.174 31.2823 147.048 32.9377 145.085 32.9377ZM161.43 30.426C159.524 30.426 157.531 31.2537 156.722 33.109L159.062 34.0794C159.553 33.109 160.506 32.795 161.487 32.795C162.845 32.795 164.26 33.6228 164.26 35.0499V35.2211C163.769 34.9357 162.758 34.5361 161.487 34.5361C158.975 34.5361 156.376 35.9061 156.376 38.475C156.376 40.8154 158.455 42.3282 160.765 42.3282C162.556 42.3282 163.538 41.529 164.144 40.6156H164.231V41.9571H166.772V35.2497C166.801 32.1671 164.462 30.426 161.43 30.426ZM161.112 40.0162C160.246 40.0162 159.033 39.5881 159.033 38.532C159.033 37.1905 160.534 36.6482 161.834 36.6482C162.989 36.6482 163.538 36.9051 164.26 37.2476C164.029 38.8745 162.643 40.0162 161.112 40.0162ZM176.1 30.7971L173.068 38.3893H172.981L169.833 30.7971H166.974L171.681 41.3863L168.996 47.2945H171.768L179.045 30.7971C179.045 30.7971 176.1 30.7971 176.1 30.7971ZM152.275 42.0142H154.932V24.5178H152.275V42.0142Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5919 10.5604C15.1876 10.9885 14.9277 11.6735 14.9277 12.5298V43.4982C14.9277 44.3544 15.1588 45.0395 15.5919 45.4676L15.7075 45.5532L33.2655 28.1995V27.7999L15.7075 10.4462L15.5919 10.5604Z",
    fill: "url(#paint0_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1034 33.9937L33.27 28.1996V27.8L39.1323 22.0059L39.2767 22.0915L46.2075 26.0018C48.1712 27.115 48.1712 28.9417 46.2075 30.0548L39.2767 33.9366C39.2478 33.908 39.1034 33.9937 39.1034 33.9937Z",
    fill: "url(#paint1_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2399 33.9084L33.2621 28.0001L15.6174 45.4395C16.2816 46.1245 17.3501 46.2101 18.563 45.5251L39.2399 33.9084Z",
    fill: "url(#paint2_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2353 22.0917L18.5296 10.475C17.3167 9.79001 16.2482 9.87563 15.584 10.5606L33.2286 28L39.2353 22.0917Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 31.6911,
    y1: 43.8083,
    x2: 2.60402,
    y2: 14.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 48.7435,
    y1: 28.0017,
    x2: 5.79908,
    y2: 28.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 24.1575,
    y1: 36.4693,
    x2: -15.2869,
    y2: -3.9108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -0.67372,
    y1: 44.0749,
    x2: 16.94,
    y2: 26.0435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.4d9ccdcb1303d757bc2ed9358ab92bd3.svg";
export { ForwardRef as ReactComponent };